/* Next */
//import Head from 'next/head'

/* Material */
import Typo from '@mui/material/Typography'
import Container from '@mui/material/Container'
import useStyles from './styles'

/* Components */
import BrLine from 'src/components/js_elements/BrLine'

const Home = () => {
  const classes = useStyles()

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Typo
        className={classes.homeTextTitle}
        component="h2"
        variant="h4"
        color="inherit"
        gutterBottom
      >
        <BrLine>Dein Online Shop von Designmoebelkaufen</BrLine>
      </Typo>

      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        Willkommen im Online-Shop von Designmoebelkaufen Interior Design
      </Typo>
      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        Sie suchen nach einer inspirierenden Auswahl an hochwertigen Möbeln,
        stilvollen Dekorationsgegenständen und weiteren Produkten, um Ihren Raum
        zu verschönern und einladend zu gestalten? Sie sind genau richtig bei
        Designmoebelkaufen!
      </Typo>
      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        Unser Shop bietet eine sorgfältig kuratierte Sammlung von Produkten, die
        von der erfahrenen Innenarchitektin und Raumausstatterin Angelina
        Minardi persönlich ausgewählt wurden. Hier finden Sie alles, was Sie
        brauchen, um Ihr Zuhause, Ihr Büro oder Ihr Geschäft mit Stil und
        Funktion zu füllen.
      </Typo>
      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        Von einzigartigen Möbelstücken bis hin zu besonderen
        Dekorationselementen - unser Angebot deckt eine Vielzahl von Stilen und
        Vorlieben ab und stellt sicher, dass Sie die perfekten Stücke für Ihr
        Raumkonzept finden.
      </Typo>
      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        In unserem Online-Shop legen wir großen Wert auf Qualität, Design und
        Funktionalität. Jedes Produkt wurde aufgrund seiner hohen Qualität und
        seines ästhetischen Designs ausgewählt, um Ihnen die besten
        Möglichkeiten zur Verbesserung Ihrer Wohn- und Arbeitsräume zu bieten.
      </Typo>
      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        Wir wissen, dass jeder Raum einzigartig ist und seinen eigenen Charakter
        hat. Deshalb bieten wir auch eine persönliche Beratung an. Sollten Sie
        Fragen zu den Produkten haben oder Unterstützung bei der Auswahl
        benötigen, zögern Sie bitte nicht, uns zu kontaktieren.
      </Typo>
      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        Wir laden Sie herzlich ein, durch unsere Produktauswahl zu stöbern, neue
        Ideen zu sammeln und die perfekten Artikel zu finden, die Ihre Räume
        bereichern. Entdecken Sie jetzt die Welt von Designmoebelkaufen Interior
        Design!
      </Typo>
      <Typo
        className={classes.homeText}
        component="p"
        variant="body2"
        color="inherit"
        paragraph
      >
        Viel Spaß beim Entdecken und Einkaufen!
      </Typo>
    </Container>
  )
}

export default Home
